import { initUtmTracking } from './front/utm-tracking.js';
import './front/is-style.js';
import './front/animate-observer.js';
import './front/event-list-geo.js';
import './front/video-teaser.js';
import './front/hero-sound.js';
import './front/booking-widget-visibility.js';

initUtmTracking();